export var CurrencyDisplay;

(function (CurrencyDisplay) {
  CurrencyDisplay["SYMBOL"] = "symbol";
  CurrencyDisplay["CODE"] = "code";
  CurrencyDisplay["NAME"] = "name";
})(CurrencyDisplay || (CurrencyDisplay = {}));